/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Pattern_XuanInputs */

const vi_tea_purchase_pattern_xuan = /** @type {(inputs: Tea_Purchase_Pattern_XuanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xuân`)
};

/**

* @param {Tea_Purchase_Pattern_XuanInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_pattern_xuan = /** @type {((inputs?: Tea_Purchase_Pattern_XuanInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Pattern_XuanInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_pattern_xuan(inputs)
});